export type CameraSide = 'front' | 'back';

const getCameraOptions = (side: CameraSide) => {
  // We ignore the deviceId for the front camera
  if (side === 'front') {
    // Without a size the browser opens the selfie camera at 640x480, too small for face matching.
    return {
      audio: false,
      video: { facingMode: 'user', width: { ideal: 1280 }, height: { ideal: 720 } },
    };
  }

  return {
    audio: false,
    video: {
      facingMode: 'environment',
      zoom: 1,
      width: { ideal: 2560 },
      height: { ideal: 1920 },
      focusMode: { ideal: 'continuous' },
    },
  };
};

export default getCameraOptions;
